export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.config.globalProperties.__ = (
        key: string,
        ...params: unknown[]
    ) => nuxtApp.$i18n.t(key, ...(params as [Record<string, unknown>?]))
})
